import { proxy } from 'valtio';

import type { User } from 'models';

const state = proxy<{
    user: User | null;
}>({
    user: null,
});

export { state };
